import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import api from './api'
import config from './config'
import {alert, modal, deleteConfirm} from './prompt'
import ViewUI from 'view-design'
import './assets/css/comm.css'
import 'view-design/dist/styles/iview.css'

import selection from './components/selection'
import { DatetimePicker } from 'vant';

Vue.config.productionTip = false;
Vue.use(ViewUI);
Vue.use(DatetimePicker);

Vue.component('selection', selection);

Vue.prototype.$store = store;
Vue.prototype.$api = api;
Vue.prototype.$config = config;
Vue.prototype.$alert = alert;
Vue.prototype.$modal = modal;
Vue.prototype.$delete = deleteConfirm;
Vue.prototype.$replaceStr = (str, index, char) => {
    return str.substring(0, index) + char + str.substring(index + 1);
};

new Vue({
    render: h => h(App),
    router,
    store
}).$mount('#app');
